<template>
	<span class="az-info">
		<v-menu max-width="500" open-on-hover offset-y top nudge-top="5" content-class="elevation-0">
			<template #activator="{ on }">
				<v-icon class="mt-1" :size="tamanhoIcone" color="primary" v-on="on">info_outline</v-icon>
			</template>
			<div class="az-info-content">
				<span>
					{{ mensagem }}
				</span>
			</div>
		</v-menu>
	</span>
</template>

<script>
export default {
	name: 'tooltip-informacao',
	props: {
		mensagem: {
			type: String,
			default: 'Informação',
		},
		tamanhoIcone: {
			type: String,
			default: '21',
		},
	},
}
</script>

<style lang="stylus" scoped>
.az-info
	.v-menu__content
		background red

	&-content
		padding 10px
		font-size 12px
		opacity 1 !important
		background #333333 !important
		text-align justify !important
		line-height 1.4
		color white
</style>
